"use strict";

module.exports = Object.freeze({
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  MOB_DRAFT: 'MOB_DRAFT',
  PENDING_UPLOADS: 'PENDING_UPLOADS',
  READY_FOR_REVIEW: 'READY_FOR_REVIEW',
  SENT_TO_RP: 'SENT_TO_RP'
});